export default __webpack_public_path__ + "static/montserrat-v15-latin-500-091b209546e16313fd4f4fc36090c757.woff2";